import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { getStorage, ref, listAll } from "firebase/storage";
import BackHomeButton from "../components/BackHomeButton";
import { db, auth } from '../firebase';

function LessonSummaryFromPDF() {

  //const auth = getAuth();
  //const db = getFirestore();
  const storage = getStorage();
  const user = auth.currentUser;

  const [standard, setStandard] = useState("");
  const [subject, setSubject] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const [lessonList, setLessonList] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState("");
  const [summary, setSummary] = useState("");
  const [message, setMessage] = useState("");

  // ✅ Get user's standard
  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return;

      const profileRef = doc(db, "profiles", user.uid);
      const snap = await getDoc(profileRef);

      if (snap.exists()) {
        setStandard(snap.data().standard);
      }
    };

    fetchProfile();
  }, [user, db]);

  // ✅ Load Subjects from Storage
  useEffect(() => {
    const fetchSubjects = async () => {

      //alert(standard);

      if (!standard) return;

      try {
        const baseRef = ref(storage, `CBSE_NCERT/Standard_${standard}`);
        const result = await listAll(baseRef);

        const subjects = result.prefixes.map(folder => folder.name);
        setSubjectList(subjects);
      } catch (err) {
        console.error("Error loading subjects:", err);
      }
    };

    fetchSubjects();
  }, [standard, storage]);

  // ✅ Load Lessons when subject selected
  useEffect(() => {
    const fetchLessons = async () => {
      if (!standard || !subject) return;

      try {
        const subjectRef = ref(storage, `CBSE_NCERT/Standard_${standard}/${subject}`);
        const result = await listAll(subjectRef);

        const lessons = result.items.map(file => file.name);
        setLessonList(lessons);
      } catch (err) {
        console.error("Error loading lessons:", err);
      }
    };

    fetchLessons();
  }, [subject, standard, storage]);

  // ✅ Generate Summary from PDF
const handleGenerateSummary = async () => {
  if (!selectedLesson) {
    alert("Please select a lesson");
    return;
  }

  try {
    setMessage("Reading lesson PDF...");
    setSummary("");

    const response = await fetch(
      "https://us-central1-project-x-demo-6329b.cloudfunctions.net/extractPdfToGemini",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          standard,
          subject,
          lesson: selectedLesson
        })
      }
    );

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    const data = await response.json();

    if (!data.success || !data.text) {
      alert("Failed to read lesson");
      setMessage("");
      return;
    }

    // 🔥 This is the full PDF text now
    setSummary(data.text);

    setMessage(`Lesson loaded successfully (${data.pages} pages)`);

  } catch (err) {
    console.error(err);
    alert("Error: " + err.message);
    setMessage("");
  }
};


  return (
    <div style={styles.card}>
      <BackHomeButton />
      <h2 style={styles.heading}>Lesson Summary</h2>

      {/* SUBJECT DROPDOWN */}
      <div style={styles.inputGroup}>
        <label style={styles.label}>Select Subject</label>
        <select
          value={subject}
          onChange={(e) => {
            setSubject(e.target.value);
            setSelectedLesson("");
            setSummary("");
          }}
          style={styles.dropdown}
        >
          <option value="">Choose Subject</option>
          {subjectList.map((sub, index) => (
            <option key={index} value={sub}>{sub}</option>
          ))}
        </select>
      </div>

      {/* LESSON DROPDOWN */}
      {subject && (
        <div style={styles.inputGroup}>
          <label style={styles.label}>Select Lesson</label>
          <select
            value={selectedLesson}
            onChange={(e) => {
              setSelectedLesson(e.target.value);
              setSummary("");
            }}
            style={styles.dropdown}
          >
            <option value="">Choose Lesson</option>
            {lessonList.map((lesson, index) => (
              <option key={index} value={lesson}>{lesson}</option>
            ))}
          </select>
        </div>
      )}

      <button style={styles.button} onClick={handleGenerateSummary}>
        ✨ Generate Summary
      </button>

      {message && <p style={styles.message}>{message}</p>}

      {summary && (
        <div style={styles.inputGroup}>
          <label style={styles.label}>Preview</label>
          <textarea
            style={styles.textarea}
            value={summary}
            readOnly
            rows={10}
          />
        </div>
      )}
    </div>
  );
}

const styles = {
  card: {
    maxWidth: "500px",
    margin: "2rem auto",
    padding: "2rem",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    fontFamily: "Segoe UI, sans-serif",
  },
  heading: {
    textAlign: "center",
    fontSize: "1.8rem",
    fontWeight: "700",
    marginBottom: "1rem",
  },
  inputGroup: { marginBottom: "1.2rem" },
  label: {
    fontWeight: "600",
    marginBottom: "0.5rem",
    display: "block",
  },
  dropdown: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  textarea: {
    width: "100%",
    padding: "0.8rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
  },
  button: {
    width: "100%",
    padding: "0.9rem",
    backgroundColor: "#4A90E2",
    color: "#fff",
    fontSize: "1.1rem",
    fontWeight: "600",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    marginBottom: "1rem",
  },
  message: {
    textAlign: "center",
    color: "#4CAF50",
    fontWeight: "500",
  }
};

export default LessonSummaryFromPDF;
